// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jCVQ","colMin":"styles_colMin__16Imx"};